import { getAxios } from "./configure-axios";
import config from "../config/vars";

let axios;

const getAxiosInstance = () => {
  if (!axios) {
    axios = getAxios();
  }
  return axios;
};

export const fetchPending = async () => {
  const instance = getAxiosInstance();
  return instance.get(`${config.baseUrl}${config.paths.pending}`);
};
export const deleteTransfer = async ({ kukey, record }) => {
  const instance = getAxiosInstance();
  return instance.put(`${config.baseUrl}${config.paths.transfer}/?kukey=${kukey}&record=${record}`);
};

export default {
  fetchPending,
  deleteTransfer
};
